/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import RadioButton from "../../../../../../components/ui/inputs/radioButton/RadioButton";

const InvoicesOld = () => {

  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <span className="mr-3 d-flex">
          <RadioButton
            //   selectedOption={instrumentOrigin}
            //   onChange={(e) => handleRadioChange(e.target.value, 'instrumentOrigin')}
            //   options={instrumentOriginOptions}
            valueName={"Invoices"}
          />
        </span>
        <span className="mr-3 d-flex">
          <RadioButton
            selectedOption={""}
            //   onChange={(e) => handleRadioChange(e.target.value, 'instrumentOrigin')}
            //   options={instrumentOriginOptions}
            valueName={"Invoices Scheadule"}
          />
        </span>
      </div>
    );
  };
  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle={`Invoices Old`}
            customHeader={true}
            headerContent={headerContent()}
          >
            <div>
              <MolGrid
                // ref={gridRef}
               // url="/Financials/GetOutstandingInvoicesList"
                // client={useGetMolGridDataMutation}
                // beforeLoad={beforeMolGridLoad}
                // afterLoad={afterMolGridLoad}
                grouping
                expandableRowGroups={true}
                paginator
                rows={99999}
                rowsPerPageOptions={[10, 25, 50, 100]}
                // virtualScrollerOptions={{ itemSize: 18 }}
                paginatorTemplate={{
                  layout:
                    "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                  RowsPerPageDropdown: (options) => {
                    // return customRowsPerPageDropdown(options, options?.value);
                  },
                }}
                scrollable
                scrollHeight="flex"
                filterDisplay="row"
                sortMode="single"
                showGridlines
                resizableColumns
                // ctxMenuItems={getCtxMenuItems}
              >
                <Column
                  field="sCompanyName1"
                  header="Document"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Date Uploaded"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Rename"
                  grouping
                  sortable
                />
                <Column field="sClientName1" header="View" grouping sortable />
                <Column
                  field="sClientName1"
                  header="Remove"
                  grouping
                  sortable
                />
              </MolGrid>
              <div className="d-flex justify-content-start pl-3  pb-3 gap-3 export-icon">
                <Buttons
                  buttonText="View Invoice"
                  // onClick={handleUnassignClick}
                  buttonTypeClassName="btn blue-btn"
                  titleText="Unassign Selected Items"
                  // isLoading={isDeleting}
                />
                <Buttons
                  buttonText="Void Invoice"
                  // onClick={handleUnassignClick}
                  buttonTypeClassName="btn blue-btn"
                  titleText="Unassign Selected Items"
                  // isLoading={isDeleting}
                />
              </div>
            </div>
            <div>
              <MolGrid
                // ref={gridRef}
               // url="/Financials/GetOutstandingInvoicesList"
                // client={useGetMolGridDataMutation}
                // beforeLoad={beforeMolGridLoad}
                // afterLoad={afterMolGridLoad}
                grouping
                expandableRowGroups={true}
                paginator
                rows={99999}
                rowsPerPageOptions={[10, 25, 50, 100]}
                // virtualScrollerOptions={{ itemSize: 18 }}
                paginatorTemplate={{
                  layout:
                    "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                  RowsPerPageDropdown: (options) => {
                    // return customRowsPerPageDropdown(options, options?.value);
                  },
                }}
                scrollable
                scrollHeight="flex"
                filterDisplay="row"
                sortMode="single"
                showGridlines
                resizableColumns
                // ctxMenuItems={getCtxMenuItems}
              >
                <Column
                  field="sCompanyName1"
                  header="Bill Date"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Schedule Amount"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Actual Bill Amount"
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Coverage Period"
                  grouping
                  sortable
                />
              </MolGrid>
              <div className="d-flex justify-content-start pl-3 pb-3 gap-3 export-icon">
                <Buttons
                  buttonText="Update Scheadule"
                  // onClick={handleUnassignClick}
                  buttonTypeClassName="btn blue-btn"
                  titleText="Unassign Selected Items"
                  // isLoading={isDeleting}
                />
              </div>
            </div>
          </CardSection>
        </div>
      </div>
    </>
  );
};
export default InvoicesOld;
